<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<p>
					<router-link tag="a" :to="{ name : 'admin.courses.index'}" class="button icon-button">
						<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
						<span>Back</span>
					</router-link>
				</p>
			</div><!--col-->
			<div class="col-12 col-xl-5">
				<div v-if="course_data">
					<div class="lightgray-content p-3 rounded mb-4">
						<p class="d-md-flex align-items-center"><strong class="mr-3 mb-1">Program: </strong> <span class="green h1">"{{ course_data.name }}"</span></span></p>
					<p class="d-md-flex align-items-center"><strong class="mr-3  mt-2 mb-1">Description:</strong> <span class="h6 regular italic mr-3  mt-2 mb-1">{{ course_data.description }}</span></p>
					</div>
				</div>
				<b-modal v-model="modal_add_lhcsa" title="Add Agency" size="lg">
					<!-- select new module or existing one -->
					<h4 class="section-title">Agencies</h4>
					<div class="table-responsive">
						Showing {{ add_organizations_table.from }} to {{ add_organizations_table.to }} of {{ add_organizations_table.total }}
						<table class="table table-bordered">
							<thead>
								<tr>
									<th class="green-content">Name</th>
									<th class="green-content">Nº HHAs</th>
									<th class="green-content">Year founded</th>
									<th class="green-content">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in all_organizations" >
									<td>{{ item.name }}</td>
									<td>{{ item.n_providers }} </td>
									<td>{{ item.year_founded }}</td>
									<td>

										<toggle-button v-model="item.in_course" 
											:labels="{ checked : 'Remove', unchecked : 'Add'}" :width="100"
											:switchColor="{ checked : red, unchecked : green }"
											:color="{ checked : red, unchecked : green, disabled : '#CCCCCC' }"
											@change="toggleOrganization(item)" :sync="true"/>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<b-pagination align="right" :total-rows="add_organizations_table.total" 
								v-model="add_organizations_table.current_page" :per-page="add_organizations_table.per_page" @change="setPageAll">
			    	</b-pagination>
				</b-modal>
				
				<div class="mb-3"><strong>Agencies coursing this program</strong> 
					<!--
					<button type="button" class="button" @click="modal_add_lhcsa = true">
					Add new
					<img class="mr-1" src="../../../assets/images/icons/solid/plus_white.svg" width="12" />-->
				</button></div>
				<div class="table-responsive">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="green-content">Name</th>
								<th class="green-content">Nº HHAs</th>
								<th class="green-content">Year founded</th>
								<th class="width-180 text-center">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in organizations" >
								<td><router-link :to="{ name: 'admin.organizations.detail', params : { id : item.id } }" tag="a" class="bold">{{ item.name }}</router-link></td>
								<td>{{ item.n_providers_course }}  </td>
								<td>{{ item.year_founded }}</td>
								<td class="text-center">
									<router-link :to="{ name: 'admin.organizations.detail', params : { id : item.id } }" tag="a" class="button">
										<img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info_white.svg" />
									</router-link>
									<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
											<div>
												<ul class="list-unstyled text-left">
													<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="selectOrganizationToDelete(item)">
														<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
														<span> Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				
				<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ organizations_table.from }} to {{ organizations_table.to }} of {{ organizations_table.total }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="organizations_table.total" 
								v-model="organizations_table.current_page" :per-page="organizations_table.per_page" @change="setPageAll">
				    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
				
		
		    	<b-modal v-model="show_delete" title="Delete LHCSA" @ok="deleteOrganization" cancel-title="No" ok-title="Yes">
			    	<div v-if="organization_to_delete != null">
						<p class="mb-2">
							Are you sure you want to delete the LHCSA {{ organization_to_delete.name }} from program {{ course_data.name }}?
						</p>
					</div>
				</b-modal>
			</div><!--col-->
			<!--
			<div class="col-12 col-xl-7">
				
				
				<admin-programs-detail-chart class="w-100" />
				
			</div><!--col-->
		</div><!--row-->
	</div>
</template>


<script>
	export default {
		data : function(){
			return {
				id : this.$route.params.id,
				course_data : null,
				//table lhcsa
				add_organizations_table : {
					current_page : 1,
					total : 15,
					per_page  : 15,
					from : 0,
					to : 0
				},
				organizations_table : {
					current_page : 1,
					total : 15,
					per_page  : 15,
					from : 0,
					to : 0
				},
				all_organizations : [],
				organizations : [],
				modal_add_lhcsa : false,
				organization_to_delete : null,
				show_delete : false,
				red : this.config.COLORS.RED,
				green : this.config.COLORS.GREEN
			}
		},

		created : function(){
			this.getOrganizations();
			this.getAllOrganizations();
			this.getCourse();
		},

		methods : {
			getCourse : function(){
				this.$store.dispatch('getCourse', { id : this.id }).then((res) => {
					this.course_data = res.data.data;
				}).catch((error) => {
					console.log(error);
				})
			},	
			getOrganizations : function(){
				var params = {
					id : this.id,
					filters : {
						page : this.organizations_table.current_page,
						count_course_id : this.id
					}
				}

				this.$store.dispatch('getCourseOrganizations', params).then((res) => {

					this.organizations_table = res.data.meta;
					this.organizations = res.data.data;
				}).catch((error) => {
					console.log(error);
				})
			},
			getAllOrganizations : function() {

				var params = {
					filters : {
						page : this.add_organizations_table.current_page,
						in_course : this.id
					}
				}
				
				this.$store.dispatch('getOrganizations', params).then((res) => {
					this.all_organizations = res.data.data;

					this.add_organizations_table = res.data.meta;
				}).catch((error) => {
					console.log(error);
				});
			},
			setPageAll : function(page){
				this.add_organizations_table.current_page = page;

				this.getOrganizations();
			},
			addOrganization : function(organization_id){
				var params = {
					id : this.id, 
					organization_id : organization_id
				}

				this.$store.dispatch('addOrganizationToCourse', params).then((res) => {
					console.log(res);
					this.getAllOrganizations();
					this.getOrganizations();
				}).catch((error) => {
					console.log(error);
				});
			},
			selectOrganizationToDelete : function(organization){
				this.organization_to_delete = organization;
				this.show_delete = true;
			},
			deleteOrganization : function(){
				var params = {
					id : this.organization_to_delete.id,
					course_id : this.id
				}

				this.$store.dispatch('deleteCourseFromOrganization', params).then((res) => {
					console.log(res);
					this.getAllOrganizations();
					this.getOrganizations();
				}).catch((error) => {
					console.log(error);
				});
			},
			toggleOrganization : function(organization){
				if(organization.in_course){
					this.addOrganization(organization.id);
				}else{
					this.organization_to_delete = organization;
					this.deleteOrganization();
				}
			}	
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/courses/AdminCourseDetailComponent.vue